import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShotApprovalStatus } from 'src/app/components/company/models/new/shot';

@Component({
	selector: 'bt-image-preview-modal',

	standalone: false,
	templateUrl: './image-preview-modal.component.html',
	styleUrl: './image-preview-modal.component.scss'
})
export class ImagePreviewModalComponent {
	readonly #dialogRef = inject(MatDialogRef<ImagePreviewModalComponent>);
	readonly data = inject<any>(MAT_DIALOG_DATA);

	preview!: string;
	valid = false;
	type: 'image' | 'video' | undefined = undefined;

	ngOnInit() {
		this.preview = this.data.preview;
		this.type = this.preview.split('/')[0] === 'data:image' ? 'image' :
		 this.preview.split('/')[0] === 'data:video' ? 'video' : undefined;
		this.validate(this.preview);
	}

	validate(src: string) {
		if(this.type === 'image') {
			const img = new Image();
			img.onload = () => {
				this.valid = img.width === img.height;
			};
			img.src = src;
		} else if(this.type === 'video') {
			const video = document.createElement('video');
			video.preload = 'metadata';
			video.onloadedmetadata = () => {
				this.valid = video.videoWidth === video.videoHeight;
			};
			video.src = src;
		}
	}

	close() {
		this.#dialogRef.close();
	}

	confirm() {
		this.#dialogRef.close(true);
	}
}
